import { render, staticRenderFns } from "./SliderMealPlan.vue?vue&type=template&id=0436c902"
import script from "./SliderMealPlan.vue?vue&type=script&lang=js"
export * from "./SliderMealPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports